<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file Basket.vue is part of event_pass_client.dev.                    -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - Basket.vue can not be copied and/or distributed                           -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<template>
    <div id="basket-modal"
         class="basket-modal noselect"
         ref="BasketModal"
    >
        <div class="basket-modal">

            <div id="basket-modal-wrapper"
                 class="basket-modal-wrapper"
                 :class="{'basket-modal-wrapper-show':showBasket}"
            >
                <!--the basker triger-->
                <div v-on:click="triggerBasketByClick()"
                     id="basket-modal-wrapper-trigger"
                     class="basket-modal-wrapper-trigger"
                >
                    <transition name="zoom">
                        <div v-if="subtotal.items > 0"
                             class="basket-modal-wrapper-trigger--counter badge badge-pill badge-primary"
                        >
                            {{subtotal.items}}
                        </div>
                    </transition>
                    <i class="material-icons" aria-hidden="true">shopping_cart</i>
                </div>
                <!--basket contents-->
                <div class="basket-modal-wrapper-container">
                    <div class="basket-modal-wrapper-container--header">
                        <slot name="header">
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="h3 m-0 font-weight-bold d-block"
                                      v-html="formatMoney(subtotal.value)"
                                ></span>
                                <i v-on:click="showBasket = false"
                                   aria-hidden="true"
                                   class="material-icons md-36 cursor-pointer">chevron_right</i>
                            </div>
                        </slot>
                    </div>
                    <!--show the loading animation-->
                    <div v-if="requesting == true" class="basket-modal-wrapper-container--body">
                        <BaseLoadingAnimation/>
                    </div>
                    <template v-else>
                        <div v-if="basketExists > 0">
                            <timerCountdown
                                    @TimeExpired="basketTimeout"
                                    :newBasketTime.sync="newBasketTime"
                                    :show_timer_result="!timerExpired"
                            >
                                <slot>
                                    <template v-if="timerExpired === false">
                                            <span v-if="reservationExtended == true" class="timer-countdown--message mr-1">
                                            Reservation extended
                                            </span>
                                        <span v-else class="timer-countdown--message mr-1">
                                            Reserved for
                                            </span>
                                    </template>
                                    <span class="timer-countdown--message timer-countdown--message-cancelled" v-if="basketExists == 1">
                                        Your
                                        <template v-if="subtotal.items > 1">
                                        reservations have
                                        </template>
                                        <template v-else>
                                        reservation has
                                        </template> been cancelled
                                    </span>
                                </slot>
                            </timerCountdown>
                            <!--the checkout-->
                            <div class="basket-modal-wrapper-container--checkout page-footer basket-modal-container--body-subtotal text-center"
                                 :style="setMobile()"
                            >
                                <slot name="footer">
                                    <div class="d-flex justify-content-between align-content-center">
                                        <div class="d-flex flex-md-column flex-row justify-content-between align-content-center align-self-center font-size-small">
                                            <div class="mr-1 mr-md-0" v-if="subtotal.items > 0">
                                                {{subtotal.items}} {{(subtotal.items)>1?'items':(subtotal.items == 0)?'':'item'}}
                                            </div>
                                            <span class="font-weight-bold"
                                                  v-html="formatMoney(subtotal.value)"
                                            ></span>
                                        </div>
                                        <a class="btn btn-secondary waves-effect waves-light"
                                           :href="content.checkout_url"
                                           @click="checkout()"
                                        >
                                            Checkout
                                        </a>
                                    </div>
                                </slot>
                            </div>
                            <!--loop the basket by tickets records-->
                            <GeminiScrollbar
                                    class="basket-scroller-container">
                                <transition-group name="slideRight" tag="div"
                                                  class="basket-modal-wrapper-container--body">
                                    <div v-for="(ticket,item_index) in basketByTicket"
                                         class="z-index-2 position-relative basket-modal-wrapper-container--body-item"
                                         :key="item_index"
                                    >
                                        <!--the ticket quantity and title-->
                                        <div class="d-flex align-items-center mb-2">
                                            <div class="fs-10 w-25">
                                                {{ticket.quantity}} x
                                            </div>
                                            <div class="w-75">
                                                <!--event name-->
                                                <small class="text-truncate"
                                                       data-vue-description="event-lang-title"
                                                >{{ticket.title}}
                                                </small>

                                                <!--title-->
                                                <h6 class="m-0" data-vue-description="ticket-title.like.name">
                                                    <small>
                                                        <bold-words :word="{text:ticket.ticket_data_title}"/>
                                                    </small>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <!--ticket type and name-->

                                            <!--ticket details-->
                                            <div class="d-flex justify-content-between align-items-center">
                                                <!--update quantity buttons-->
                                                <div class="btn-group mr-1"
                                                     data-toggle="buttons"
                                                >
                                                    <div v-on:click="quantityUpdate(ticket.id,false)"
                                                         class="ticket-item--action basket-btn btn btn-sm btn-primary waves-effect waves-light"
                                                    >
                                                        <i class="material-icons"
                                                           aria-hidden="true">remove_circle_outline</i>
                                                    </div>
                                                    <div v-on:click="quantityUpdate(ticket.id,true)"
                                                         class="ticket-item--action basket-btn btn btn-sm btn-primary waves-effect waves-light"
                                                    >
                                                        <i class="material-icons"
                                                           aria-hidden="true">add_circle_outline</i>
                                                    </div>
                                                </div>
                                                <div class="font-weight-bold"
                                                     v-html="formatMoney(ticket.total)"
                                                ></div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </transition-group>
                            </GeminiScrollbar>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {_} from 'underscore';
    // import {VueHammer} from 'vue2-hammer';
    import {truncate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.string'
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {ticket_types} from '../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import User from '../../../../../app/Shared/Resources/Assets/js/helpers/user';
    import whatDevice from '../../tools/mobile-devices';
    import BasketToastr from '../basket/BasketToastr.js';

    import {addMinutes, addSeconds, differenceInSeconds} from 'date-fns';

    import GeminiScrollbar from 'vue-gemini-scrollbar'
    Vue.use(GeminiScrollbar)
    // Vue.use(VueHammer);
    // VueHammer.config.pan = {
    // 	threshold: 200
    // };
    Vue.component('bold-words', require('../../../../../app/Shared/Resources/Assets/js/components/BoldWords'))
    Vue.component('timerCountdown', require('./timerCountdown'))
    export default {
        props: {
            content: Object,
            timerLengthInMinutes: {
                type: Number, // in minutes
                default: 0
            },
        },
        mixins: [BasketToastr],
        created() {
            // console.log('test')
        },
        destroyed() {

        },
        async mounted() {
            let self = this;
            self.updateUrl = self.content.update;
            if (!self.loaded) {
                return;
            }

        },
        data() {
            return {
                basketTimeLeft: 0,
                newBasketTime: 0,
                basketExpired: 0,
                extendedCount: 0,
                updateUrl: '',
                basketTime: {
                    starts: null,
                    expires: null,
                    counter: 0,
                },
                timerCounter: {
                    now: new Date(),
                    timer: null,
                    endDate: null,
                    ended: false
                },
                requesting: true,
                loaded: false,
                showBasket: false,
                triggerElm: '#basket-modal-wrapper-trigger',
                basket: {},
                basketByTicket: {},
                basketItemTypes: {
                    season: [],
                    single: [],
                    bulk: [],
                    vip: [],
                },
                subtotal: {
                    value: 0,
                    items: 0
                },
                isShowing: false,
                pressed: false,
                dragPos: -295,
                dragPosOffset: 0,
                // dragPosOffset:-70,
                previousPos: -294,
                direction: 1,
                boxOffset: 1,
                boxWidth: '',
                DIRECTION_LEFT: 2,
                DIRECTION_RIGHT: 4,
                DIRECTION_NONE: 1,
                resizeTimeout: null,
                estLocalStorage: []

            }
        },
        watch: {
            content(items) {
                this.init();
            },
        },
        methods: {
            /*
                        setStartTime(start_time) {
                            //
                            // Possible unwanted
                            this.$set(this.basketTime, 'starts', new Date(start_time*1000));
                        },
            */
            /*
                        setExpiryTime(expiry_time, start_time) {
                            //
                            // Possible unwanted
                            let timeNow = Date.now();

                            if (typeof expiry_time !== 'undefined' && expiry_time !== null) {
                                let self = this;
            //                    self.$set(self.timerCounter, 'endDate', new Date(expiry_time*1000));
                                self.$set(self.timerCounter, 'endDate', new Date(timeNow+((expiry_time- start_time)*1000)));
                            }

                        },
            */
            basketTimeout() {
                let self = this;
                // self.basketExpired = 1;

                self.processAxiosRequest(true, {
                    url: self.content.update, method: 'post'
                });
            },
            /*
                        setTimeoutTimer(time_remaining) {
                            //
                            // Possible unwanted
                            if (typeof time_remaining !== 'undefined' && time_remaining !== null) {
                                let self = this;
                                self.$set(self.timerCounter, 'endDate', addSeconds(new Date(), time_remaining))
                            }
                        },
            */
            init() {
                let self = this;

                // on event hub in config.js we can recieve triggers here
                this.$basketController.$on('read_basket', function () {
                    self.processAxiosRequest(false);
                });
                this.processAxiosRequest(true);
            },
            userLoggedIn() {
                if ('id' in User()) {
                    return true;
                }
                return false;
            },
            log(...args) {
                console.log(...args);
            },
            first(ticket) {
                return (ticket.length <= 0) ? null : ticket[0];
            },
            deleteTicket(ticket) {
                console.log('delete ticket', ticket);
            },
            groupPrice(tickets) {
                let price = 0,
                    ticketsLength = tickets.length;

                for (let i = 0; i < ticketsLength; ++i) {
                    let obj = tickets[i];
                    price = price + tickets[i].price;
                }
                return price;
            },
            groupQuantity(tickets) {
                // console.log('tickets',tickets);
                return _.size(tickets);
            },
            setTickets(basket) {

                let self = this,
                    tmp = {};
                self.timerCounter.ended = false;
                self.subtotal.value = 0;

                self.subtotal.items = basket.count;

                self.extendedCount = basket.extension_attempts;
//                self.setTimeoutTimer(basket.time_remaining);

//                self.setStartTime(basket.time_started);
//                self.setExpiryTime(basket.time_expires, basket.time_started);

                for (let itemKey in basket.items) {
                    try {
                        let ticket = basket.items[itemKey],
                            ticketId = ticket.ticket_id,
                            ticketType = ticket.type,
                            value = parseInt(ticket.price),
                            items = parseInt(ticket.qty),
                            created_at = parseInt(ticket.created_at)
                        ;
                        self.subtotal.value = self.subtotal.value + (value * items);

                        if ((ticketId in tmp)) {
                            let existingTicket = tmp[ticketId];
                            if (parseInt(existingTicket.created_at) < created_at) {
                                // if previously added ticket in the tmp array has older timestamp then use that
                                items += existingTicket.quantity;
                                created_at = existingTicket.created_at;
                                value = existingTicket.price;
                            } else {
                                items += existingTicket.quantity;
                            }
                        }

                        tmp[ticketId] = {
                            id: ticketId,
                            type: ticketType,
                            tickets: [],
                            quantity: items,
                            price: value,
                            created_at: created_at,

                            /**
                             * single ticket title is the event
                             * bulk ticket title is the ticket_group title
                             */
                            title: self.setTitle(ticket),

                            ticket_data_title: self.setDataTitle(ticketType, ticket),

                            description: self.setDescription(ticket),
                            total: items * value
                        };
                        // tmp[ticketId].tickets.push(ticket);
                    } catch (e) {
                        console.error(e)
                    }
                }
//                console.log('tickets ',tmp);
                return tmp;
            },
            groupByTicket(basket) {
                let self = this,
                    tmp = {};

                self.subtotal.value
                    = self.subtotal.items
                    = 0;

//                for (var basketKey in basket) {
                for (let itemKey in basket.items) {

                    /**
                     * For single tickets basket item is the event so lang is the event name
                     *
                     */
                    let basketItem = basket.items[itemKey],
                        ticketId = basketItem.ticket_id,
                        ticketType = basketItem.type,
                        value = parseInt(basketItem.price),
                        items = parseInt(basketItem.qty);

                    self.subtotal.value = self.subtotal.value + (value * items);
                    self.subtotal.items = self.subtotal.items + items;
                    if (!(ticketId in tmp)) {
                        tmp[ticketId] = {
                            id: basketItem.ticket_id,
                            type: ticketType,
                            tickets: [],
                            quantity: 0,
                            price: basketItem.price,

                            /**
                             * single ticket title is the event
                             * bulk ticket title is the ticket_group title
                             */
                            title: self.setTitle(ticket),

                            ticket_data_title: self.setDataTitle(ticketType, ticket),

                            description: self.setDescription(ticket),

                            total: 0
                        };
                    }
                    tmp[ticketId].tickets.push(basketItem);
                    tmp[ticketId].quantity = tmp[ticketId].quantity + 1;
                    tmp[ticketId].total = tmp[ticketId].total + basketItem.price;
                }
                return tmp;
            },
            quantityUpdate(ticket_id, add) {
                let self = this,
                    ticketId = ticket_id,
                    increaseQuantity = add,
                    dontOpenDisplay = increaseQuantity,
                    url = increaseQuantity == true ? this.content.add_ticket_url : this.content.remove_ticket_url;
                axios
                    .post(url + '/' + ticketId, {
                        timeLeft: this.basketTimeLeft
                    })
                    .then(function (response) {
                        // console.log('response',response)
                        if (increaseQuantity) {
                            if (response.data.success) {
                                self.processAxiosRequest(dontOpenDisplay);
                            } else if (response.data.exceeded === true) {
                                let maxNumberOfTickets = response.data.limit;

                                self.showToastr('warning', {message: 'Only ' + maxNumberOfTickets + ' per purchase'});
                                self.requesting = false;
                            } else {
                                self.showToastr('warning', {message: 'Ticket sold out'});
                                self.requesting = false;
                            }
                        }
                    })
                    .catch(function () {
                    });
                // only show spinner when adding not removing
                if (add) {
                    self.requesting = true;
                }
                // user removed an item from the basket
                else {

                    let targetTicketArray = self.basketByTicket[ticketId].tickets,
                        totalPrice = self.subtotal.value,
                        price = self.basketByTicket[ticketId].price,
                        quantity = self.basketByTicket[ticketId].quantity,
                        total = self.basketByTicket[ticketId].total;

                    // if this the matching ticket only has a quantity of one
//                    if (targetTicketArray.length == 1) {
                    if (quantity == 1) {
                        self.$delete(self.basketByTicket, ticketId);
                    } else {
                        // take the last inserted matching ticket from the basket
                        self.basketByTicket[ticketId].tickets.pop();
                        // update the quantities
                        self.basketByTicket[ticketId].quantity = quantity - 1;
                        self.basketByTicket[ticketId].total = total - price;
                    }
                    self.subtotal.items = self.subtotal.items - 1;
                    self.subtotal.value = self.subtotal.value - price;

                    if (self.subtotal.items == 0) {

                        this.newBasketTime = 0;
                        window.localStorage.ckhBskStatus = 0;

//                        setTimeout(function(){location.reload()}, 1000);
                    }
                }

            },
            /**
             * Updates total and badge counter
             */
            summarys() {
                let self = this;

                //reset values
                // self.subtotal.value = self.subtotal.items = 0;

                // loop each ticket
                // for (var selfKey in self.basketByTicket) {
                //     if (selfKey in self.basketByTicket) {
                //         let tickets = self.basketByTicket[selfKey].tickets;
                //
                //         if (typeof tickets !== 'undefined' && tickets !== null) {
                //             let ticketLength = tickets.length;
                //
                //             for (let i = 0; i < ticketLength; ++i) {
                //                 let item = tickets[i],
                //                     value = parseInt(item.ticket_data.price),
                //                     items = parseInt(item.ticket_data.quantity);
                //
                //                 self.subtotal.value = self.subtotal.value + (value * items);
                //                 self.subtotal.items = self.subtotal.items + items;
                //             }
                //         }
                //     }
                // }
            },
            setTitle(ticket) {
                return ticket.title
            },
            /**
             * @note ticket.title is the event title if is not a multi event ticket
             * */
            setDataTitle(ticketType, ticket) {
                return (ticketType == 'season' || ticketType == 'bulk') ? ticket.title : ticket.ticket_title
            },
            setDescription(ticket) {
                return (typeof ticket.description !== 'undefined' && ticket.description !== null)
                       ? ticket.description
                       : ''
            },
            ticketTypeIconClass(item, tilt, type) {
                return ticket_types(item.ticket_type, tilt, type);
            },
            formatMoney(price) {
                return formatMoney(price, {
                    code: $('body').data('currency')
                });
            },
            truncateLang(path, item) {
                let word = lang(path, item);
                return truncate(word, 50, true);
            },
            lang(path, item) {
                return lang(path, item);
            },
            triggerBasketByClick() {
                let self = this;

                /** close if open **/
                if (self.showBasket) {
                    self.showBasket = false;
                    return;
                }
                this.processAxiosRequest(false);
            },
            processAxiosRequest(dontOpen, params) {

                let self = this,
                    _dontOpen = (typeof dontOpen !== 'undefined' && dontOpen !== null) ? dontOpen : false,
                    _get_url = typeof params !== "undefined" && params !== null ? params.url : self.content.url;

                axios({
                    method: typeof params !== "undefined" && params !== null ? params.method : 'get',
                    url: _get_url,
                    params: {timeLeft: this.basketTimeLeft}
                })
                    .then((response) => {
                        if (response.status !== 200) {
                            console.error('No Response');
                            return;
                        }

                        if (response.data.basket !== null) {

                            if (response.data.success === true && response.data.basket === null) {
                                // Basket doesn't even exists
                                self.basketExpired = 0;
                                window.localStorage.ckhBskStatus = 0;

//                                sessionStorage.setItem('ckhBskStatus', 0);

                            }
                            if (response.data.success === true && typeof response.data.basket.count !== "undefined" && response.data.basket.count > 0) {

                                // Basket exists with some contents
                                if (response.data.timer !== null && response.data.timer > 0) {

                                    let newBasketTimeLeftInSession = parseInt(window.localStorage.ckhBskStatus);

                                    if (newBasketTimeLeftInSession > 0) {
                                        self.newBasketTime = newBasketTimeLeftInSession;

                                    } else {
                                        self.newBasketTime = response.data.timer;
                                        window.localStorage.ckhBskStatus = parseInt(self.newBasketTime);

//                                        sessionStorage.setItem('ckhBskStatus', parseInt(self.newBasketTime));

                                    }

                                    if (response.data.basket.extension_attempts > 0 && self.newBasketTime > 0) {
                                        self.newBasketTime = (response.data.basket.extension_attempts / 100) + parseInt(self.newBasketTime);

                                    }

                                }
                                self.basketExpired = 2;

                            }
                            if (response.data.success === false && typeof response.data.basket.count === "undefined") {
                                // Basket content has been emptied
                                self.basketExpired = 1;
                                window.localStorage.ckhBskStatus = 0;
//                                sessionStorage.setItem('ckhBskStatus', 0);
                            }

                            self.basketByTicket = self.setTickets(response.data.basket)
                        }

                        if (response.data.code !== null) {

                            let code = JSON.parse(response.data.code);

                            if (code.code == 921) {
                                self.showToastr('warning', {message: code.message});
                            }
                        }


                        // show the counter badge
                        self.summarys();

                        if (!dontOpen) {
                            self.showBasket = true;
                        }
                        self.requesting = false;
                    })
                    .catch(function (e) {
                        console.error('No Response', e);
                    });

            },
            getWidth() {
                this.boxWidth = $('#basket-modal-wrapper').width();
                return $('#basket-modal-wrapper').width();
            },
            checkout() {
                window.location.href = this.content.checkout_url;
            },
            setMobile() {
                let isMobile = whatDevice();
                // console.log('isMobile',isMobile);
                if (isMobile == 'ios') {
                    return `height:15rem`
                }
                return null;
            }
        },
        computed: {
            //
            // Computed tidied up done.
            reservationExtended() {
                return (this.extendedCount > 0);
            },
            basketExists() {
                return this.basketExpired;
            },
            timerExpired() {
                return (this.basketExpired == 1);
            },
        }

    }
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/Basket.vue